// Iter53: centralni popis uloga koje primaju GO/WFH rješenja (svi osim admin).
// Koristi se u CollectiveIssueDialog, BehalfVacationDialog i bilo gdje drugdje
// gdje treba pokazati popis "zaposlenika koji idu na godišnji".
export const VACATION_ELIGIBLE_ROLES = [
  "employee",
  "employee_teaching",
  "employee_nonteaching",
  "manager",
  "prodekan",
  "secretary",
  "dean",
];

export function isVacationEligible(user) {
  return VACATION_ELIGIBLE_ROLES.includes(user?.role);
}
